import {
  AfterViewChecked,
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { Global } from '../../models/global.model';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-utility-toolbar',
  templateUrl: './utility-toolbar.component.html',
  styleUrls: ['./utility-toolbar.component.scss'],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
})
export class UtilityToolbarComponent implements OnInit, AfterViewChecked {
  private route = inject(Router);
  private ss = inject(SessionStorageService);

  @Input() links = ['home', 'dash', 'repBehavior', 'reporting', 'caseExplorer'];
  @Input() vertical = false;
  @Input() current = null;
  @Output() toggleCollapse = new EventEmitter();

  rights: string[] = [];
  homeOfficeUser = false;
  hasRepCodes = false;
  isProducer = false;
  private globals: Global;
  isCollapsed = false;

  ngOnInit() {
    this.isCollapsed = this.ss.get('utilityToolbarCollapsed');
    this.rights = this.ss.get('rights');
    this.globals = this.ss.get('globals');
    const repCodes = this.ss.get('repUnits');

    if (this.globals?.user?.managerUnitCount > 0) {
      this.homeOfficeUser = true;
    } else if (this.globals?.user?.managerUnitCount === 0) {
      this.homeOfficeUser = false;
    }

    if (repCodes && repCodes.length > 0) {
      this.hasRepCodes = true;
      this.isProducer = this.rights?.includes('BookManagement');
    }
  }

  ngAfterViewChecked(): void {
    if (
      document.getElementsByClassName('page-container')[0] &&
      !document
        .getElementsByClassName('page-container')[0]
        .classList.value.includes('toolbar-parent') &&
      !this.vertical
    )
      document
        .getElementsByClassName('page-container')[0]
        .classList.add('toolbar-parent');
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  toggleVerticalCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.toggleCollapse.emit();
    if (this.isCollapsed) {
      this.ss.set('utilityToolbarCollapsed', this.isCollapsed);
    } else {
      this.ss.remove('utilityToolbarCollapsed');
    }
  }

  dashboardTooltip() {
    if (this.isCollapsed) {
      if (this.rights.includes('SE')) {
        return 'Dashboard';
      } else {
        return 'Firm Overview';
      }
    } else {
      return '';
    }
  }
}
